<template>
      <div id="one-more-question-current">
            <section class="section intro-hero animate__animated animate__fadeIn">
                  <BackButton link="/benefits-current" />
                  <div class="grid-container max">
                        <div class="intro-hero-grid">
                              <div class="intro-hero-left">
                                    <h1>One more<br />question</h1>
                              </div>
                              <div class="intro-hero-right">
                                    <p class="oneq-question">Now that you&rsquo;ve reviewed the 2027 plan options, would you like to keep your current plan &mdash; or do you want to make a change?</p>
                                    <div class="oneq-options">
                                          <label class="oneq-option">
                                                <input type="radio" value="Yes" v-model="keepPlan" />
                                                <span>I want to keep the same plan I had last year.</span>
                                          </label>
                                          <label class="oneq-option">
                                                <input type="radio" value="No" v-model="keepPlan" />
                                                <span>I&rsquo;d like to make a change in my Anthem plan options.</span>
                                          </label>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div class="intro-hero-btn-wrap">
                        <button class="intro-hero-btn" @click="storeData()"><span>Next</span></button>
                  </div>
            </section>
      </div>
</template>

<script>
import BackButton from "../components/BackButton"
import gaEventMixin from "../mixins/gaEventMixin"
export default {
      name: "SHBPOneMoreQuestionCurrent",
      data() {
            return {
                  keepPlan: this.$store.state.keepPlan,
            }
      },
      methods: {
            storeData() {
                  const keepPlan = this.keepPlan
                  if ((!keepPlan)) {
                        let message = 'Please make a choice below.'
                        this.$swal({
                              html: message,
                              showCancelButton: false
                        })
                  }
                  else {
                        this.$store.commit('changeKeepPlan', keepPlan)
                        this.track("Choice", keepPlan + " Coverage")
                        if (keepPlan == "No") this.$router.push('/plan-options-current')
                        else this.$router.push('/summary-current')
                        localStorage.setItem("antKeepPlan", keepPlan)
                  }
            }
      },
      mounted() {
            window.scrollTo(0, 0)
      },
      components: { BackButton },
      mixins: [gaEventMixin]
}
</script>

<style lang="scss">
#one-more-question-current {
      .intro-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 100px 0;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .intro-hero-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  gap: 40px;
            }

            .intro-hero-left {
                  flex: 1 1 480px;
                  max-width: 640px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(4.25rem, 6.5vw, 5.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }

            .intro-hero-right {
                  flex: 1 1 360px;
                  max-width: 460px;

                  .oneq-question {
                        color: #012E58;
                        font-size: 1.25rem;
                        font-weight: 600;
                        line-height: 1.4;
                        margin-bottom: 24px;
                  }

                  .oneq-options {
                        display: flex;
                        flex-direction: column;
                        gap: 20px;
                  }

                  .oneq-option {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        cursor: pointer;

                        input[type="radio"] {
                              width: auto;
                              margin: 0;
                              flex-shrink: 0;
                        }

                        span {
                              flex: 1;
                              min-width: 0;
                              color: #3F3A4E;
                              font-size: 1.125rem;
                              line-height: 1.3;
                        }
                  }
            }

            .intro-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .intro-hero-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 100px 24px;
                  justify-content: flex-start;

                  .back-btn {
                        left: 2rem;
                  }

                  .intro-hero-grid {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 0;
                  }

                  .intro-hero-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 11vw, 5.25rem) !important;
                        }
                  }

                  .intro-hero-right {
                        flex: 0 0 auto;
                        width: 100%;
                        max-width: 100%;
                        margin-top: 48px;

                        .oneq-question {
                              font-size: 1.125rem;
                        }
                  }
            }
      }
}
</style>
